// removed by extract-text-webpack-plugin
module.exports = {"dashboard-card-container":"dashboard-card-container___c1_q","data-box":"data-box__GV5Dl","dashboard-item":"dashboard-item__2PEaN","dashboard-item-data":"dashboard-item-data__1xkJu","pending-action":"pending-action__wYQz_","title":"title__1Nyu6","sub-title":"sub-title__y0yhK","important-item":"important-item__3n4aK","action-btn":"action-btn__1pihw","tax-plans":"tax-plans__3YNKP","text-red":"text-red__cDJw-","text-green":"text-green__3YJ_2"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/carousalCard.scss
// module id = 497
// module chunks = 68